import ppmFavicon from '../../../../assets/img/logo/ppmfavicon.png';
import './print-tone-collection.header.scss';

export const PrintToneCollectionHeader = () => {
  return (
    <div className="print_tone_correction_header">
      <div className="print_tone_correction_header__left">
        <div className="print_tone_correction_header__logo">
          <img src={ppmFavicon} alt="" />
        </div>
      </div>
    </div>
  );
};
